export default "__VITE_ASSET__Bke0Lbk0__"